module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cn-e4f6436aa2c562521a6ed835dfe48af9.svg";